import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AumicoAbcpConfig, AumicoAbcpConfigService } from '../abcp-data.config';
import { IAccountLedgerPage } from '../models/account-ledger.model';

/** The Kontenblatt of one account. Read-only. */
@Injectable()
export class AccountLedgerService {
    private readonly projectsEndpoint: string;

    public constructor(private readonly http: HttpClient, @Inject(AumicoAbcpConfigService) config: AumicoAbcpConfig) {
        this.projectsEndpoint = `${config.apiGateway}projects`;
    }

    public page(projectId: string, accountId: string, cursor: string | null): Observable<IAccountLedgerPage> {
        const params = cursor === null ? new HttpParams() : new HttpParams().set('cursor', cursor);
        return this.http.get<IAccountLedgerPage>(
            `${this.projectsEndpoint}/${projectId}/accounts/${encodeURIComponent(accountId)}/ledger`,
            { params },
        );
    }
}
